import { render, staticRenderFns } from "./bodyComposition.vue?vue&type=template&id=f72a7cea&scoped=true&"
import script from "./bodyComposition.vue?vue&type=script&lang=js&"
export * from "./bodyComposition.vue?vue&type=script&lang=js&"
import style0 from "./bodyComposition.vue?vue&type=style&index=0&id=f72a7cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a7cea",
  null
  
)

export default component.exports